import {createIcon} from '@kaena1/mm-ui-components';
import React from 'react';

export const DarkGreenCheckmark = createIcon({
  viewBox: '0 0 32 32',
  defaultSize: 'xsmall',
  defaultFill: 'primary',
  path: (
    <>
      <circle cx="16" cy="16" r="16" fill="#3B664A" />
      <path
        d="M23.1924 9.00079C22.736 9.01521 22.3033 9.22177 21.9844 9.57673C19.2045 12.6002 16.6655 15.5649 13.9953 18.5234L10.8565 15.7927C10.676 15.6362 10.4689 15.5198 10.2474 15.45C10.0259 15.3803 9.79311 15.3586 9.56342 15.3863C9.33475 15.4139 9.11223 15.4903 8.91022 15.6112C8.70719 15.7321 8.52979 15.8949 8.3852 16.0905C8.24062 16.2861 8.13398 16.5106 8.06937 16.7513C8.00477 16.9918 7.98529 17.2438 8.01092 17.4929C8.03656 17.7418 8.10629 17.9829 8.21806 18.2023C8.32881 18.4217 8.47954 18.6152 8.66002 18.7717L13.0529 22.5847C13.3913 22.8775 13.8179 23.0242 14.2506 22.9967C14.6823 22.9693 15.0905 22.7695 15.395 22.4357C18.5554 18.9998 21.3866 15.6251 24.4741 12.2676C24.7264 11.9992 24.8976 11.6545 24.9663 11.2786C25.035 10.9025 24.9981 10.5128 24.8597 10.1601C24.7213 9.80736 24.4885 9.50814 24.1911 9.30128C23.8937 9.09452 23.5461 8.98978 23.1924 9.00079Z"
        fill="#FFFEF4"
      />
    </>
  ),
});
